import imagesLoaded from 'imagesloaded';
import Modernizr from 'modernizr';

// touch test for backwards compatibility
Modernizr.addTest('touch', () => {
  let bool;
  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {bool = true;} else {
    const query = ['@media (', Modernizr._prefixes.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join('');
    Modernizr.testStyles(query, node => {bool = node.offsetTop === 9;});
  }
  return bool;
});
window.Modernizr = Modernizr;
window.imagesLoaded = imagesLoaded;

import '../../../libs/timeago/timeago.js';
import '../../../libs/mbp/js/helper.js';
import './embed/embed_libs.js';
